import ModalVm          from './vmodels/modal_vm.js';

window.modal_app = ModalVm ;

